import React from "react";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler);

export const CHART_COLORS = ["#6366f1", "#0ea5e9", "#10b981", "#f59e0b", "#f43f5e", "#8b5cf6", "#14b8a6", "#eab308"];

const baseOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: { grid: { display: false }, ticks: { font: { size: 11 } } },
    y: { border: { display: false }, ticks: { font: { size: 11 } } },
  },
};

export const LineChart = ({ labels = [], data = [], height = 240, label = "" }) => (
  <div style={{ height }}>
    <Line
      options={baseOptions}
      data={{
        labels,
        datasets: [
          {
            label,
            data,
            borderColor: CHART_COLORS[0],
            backgroundColor: "rgba(99,102,241,0.14)",
            fill: true,
            tension: 0.35,
            pointRadius: 2,
          },
        ],
      }}
    />
  </div>
);

export const BarChart = ({ labels = [], data = [], height = 240, label = "", horizontal = false }) => (
  <div style={{ height }}>
    <Bar
      options={{ ...baseOptions, indexAxis: horizontal ? "y" : "x" }}
      data={{
        labels,
        datasets: [{ label, data, backgroundColor: CHART_COLORS[0], borderRadius: 6, maxBarThickness: 34 }],
      }}
    />
  </div>
);

export const DoughnutChart = ({ labels = [], data = [], height = 240 }) => (
  <div style={{ height }}>
    <Doughnut
      options={{
        responsive: true,
        maintainAspectRatio: false,
        cutout: "62%",
        plugins: { legend: { position: "bottom", labels: { boxWidth: 12, font: { size: 11 } } } },
      }}
      data={{ labels, datasets: [{ data, backgroundColor: CHART_COLORS, borderWidth: 0 }] }}
    />
  </div>
);
